const MARKETPLACE_APP_CONSTANTS = {
  CHECK_USER_LOGIN_STATUS: "CHECK_USER_LOGIN_STATUS",
  PROFILE_UPDATE_REQUIRED: "PROFILE_UPDATE_REQUIRED",
  TERMS_OF_SERVICE_REQUIRED: "TERMS_OF_SERVICE_REQUIRED",
  GET_STORE_SKIN: "GET_STORE_SKIN",
  GET_STORE_CONFIGURATION: "GET_STORE_CONFIGURATION",
}
export default MARKETPLACE_APP_CONSTANTS
